import { createAction, props } from '@ngrx/store';
import { CustomerAccount } from '@dch/common-business-logic';

export const GET_CUSTOMER_ACCOUNT_REQUEST = 'GET_CUSTOMER_ACCOUNT_REQUEST';
export const GET_CUSTOMER_ACCOUNT_SUCCESS = 'GET_CUSTOMER_ACCOUNT_SUCCESS';
export const GET_CUSTOMER_ACCOUNT_FAILURE = 'GET_CUSTOMER_ACCOUNT_FAILURE';
export const SET_CUSTOMER_LANGUAGE = 'SET_CUSTOMER_LANGUAGE';

export const getCustomerAccountRequest = createAction(
  GET_CUSTOMER_ACCOUNT_REQUEST
);

export const getCustomerAccountSuccess = createAction(
  GET_CUSTOMER_ACCOUNT_SUCCESS,
  props<{ customerAccount: CustomerAccount }>()
);

export const getCustomerAccountFailure = createAction(
  GET_CUSTOMER_ACCOUNT_FAILURE
);

export const setCustomerLanguage = createAction(
  SET_CUSTOMER_LANGUAGE,
  props<{ language: 'en' | 'fr' | 'nl' | 'de' }>()
);
